const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7996efdee35323d0537dedf0e83a160dd3fa7884"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web@lampant"]={id:"7996efdee35323d0537dedf0e83a160dd3fa7884"};
      